export default __webpack_public_path__ + "static/media/gallery-07_full.1e392e7f.jpg";